import { API_URL } from './env';

export class ApiError extends Error {
  status: number;
  constructor(message: string, status: number) {
    super(message);
    this.status = status;
  }
}

interface RequestOptions {
  method?: 'GET' | 'POST' | 'PUT' | 'PATCH' | 'DELETE';
  body?: unknown;
  token?: string | null;
}

/**
 * Codigo de la aplicacion de la Suite activa en esta pestana (Control
 * Operativo, Gestion Humana, ...), fijado por ApplicationProvider al entrar a
 * una aplicacion. El backend lo usa (header `X-Lcc-Application`) para
 * resolver el Rol/Pantallas de la persona PARA ESA aplicacion puntual - ver
 * requireApplication en la API. null antes de elegir aplicacion (Selector).
 */
let currentApplicationCode: string | null = null;
export function setCurrentApplicationHeader(code: string | null) {
  currentApplicationCode = code;
}

/** Cliente HTTP fino usado por los repositorios "remote" (llaman al Worker en Cloudflare). */
export async function apiRequest<T>(path: string, opts: RequestOptions = {}): Promise<T> {
  const res = await fetch(`${API_URL}${path}`, {
    method: opts.method ?? 'GET',
    headers: {
      'Content-Type': 'application/json',
      ...(opts.token ? { Authorization: `Bearer ${opts.token}` } : {}),
      ...(currentApplicationCode ? { 'X-Lcc-Application': currentApplicationCode } : {}),
    },
    body: opts.body ? JSON.stringify(opts.body) : undefined,
  });

  if (!res.ok) {
    const text = await res.text().catch(() => '');
    let message = text || res.statusText;
    try {
      const parsed = JSON.parse(text);
      if (parsed?.error) message = parsed.error;
    } catch {
      // El cuerpo no era JSON: se deja el texto crudo como mensaje.
    }
    throw new ApiError(message, res.status);
  }
  if (res.status === 204) return undefined as T;
  return res.json() as Promise<T>;
}

/** Descarga un archivo protegido (ej. foto de una marcación) con la sesion y devuelve una URL temporal para <img>. */
export async function apiBlobUrl(path: string, token: string | null): Promise<string> {
  const res = await fetch(`${API_URL}${path}`, {
    headers: {
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
      ...(currentApplicationCode ? { 'X-Lcc-Application': currentApplicationCode } : {}),
    },
  });
  if (!res.ok) {
    const text = await res.text().catch(() => '');
    let message = text || res.statusText;
    try { const parsed = JSON.parse(text); if (parsed?.error) message = parsed.error; } catch { /* texto crudo */ }
    throw new ApiError(message, res.status);
  }
  return URL.createObjectURL(await res.blob());
}
